export default __webpack_public_path__ + "static/media/img5.1dc907a8.png";